















import Vue from 'vue'
import {Component, Emit, Prop} from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ActionLabel from './ActionLabel.vue'
import { IRecipient } from '@/entities/notices'
import { SuggestionAction } from '@/entities/suggestions'
import TextWithHighlight from '@/components/TextWithHighlight.vue'
import { relativeDate } from '@/utils/time'

@Component<DialogBody>({
    components: {
        ActionLabel,
        TextWithHighlight
    }
})
export default class DialogBody extends Vue {
    @Prop({ type: String, default: '' }) public title!: string
    @Prop({ type: String, default: '' }) public subtitle!: string
    @Prop({ type: String, default: '' }) public body!: string
    @Prop({ type: Number, default: 0 }) public created!: number
    @Prop({ type: String, default: '' }) public action!: SuggestionAction
    @Prop({ type: String, default: '' }) public type!: string
    @Prop({ type: Boolean, default: true }) public canDelete!: boolean

    @Emit('delete')
    onDelete(e) {
        e.stopPropagation()
        return e
    }

    @Getter public suggestionMentionUsers!: IRecipient[]

    public formatTime(time: number) {
        return relativeDate(time)
    }

    public get highlights() {
        return this.suggestionMentionUsers.map((user) => `@${user.name}`)
    }
}
